import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ContractSigningWidgets from '../../../widgets/ContractSigning/ContractSigningWidgets'
import { getContractor } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'

export default function ContractSigning() {
  //ขั้นที่ 4 การลงนามสัญญา
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const mockSchema = {
    header: 'ขั้นที่ 4 การลงนามสัญญา',
    subHeader: '',
    signing: {
      header: 'เสนอผู้มีอำนาจลงนาม',
      signingList: [
        {
          no: 1,
          fileType: 'ดร. วิชัย สำราญศักดิ์',
          fileName: 'พยาน',
          fileSize: '20Mb',
          uploadDate: '16 กพ. 2564',
          viewAndDownLoad: 'แสดง  ดาวน์โหลด',
        },
        {
          no: 2,
          fileType: 'ดร. ยิ่งยง พัฒนา',
          fileName: 'ผู้อนุมัติทัน',
          fileSize: '10Mb',
          uploadDate: '13 กพ. 2564',
          viewAndDownLoad: 'แสดง  ดาวน์โหลด',
        },
        {
          no: 3,
          fileType: 'ดร. สิวัฒ ไกรศร',
          fileName: 'พยาน',
          fileSize: '5Mb',
          uploadDate: '12 กพ. 2564',
          viewAndDownLoad: 'แสดง  ดาวน์โหลด',
        },
        {
          no: 4,
          fileType: 'ดร. มุกดา บรรชล',
          fileName: 'ผู้รับทุน',
          fileSize: '5Mb',
          uploadDate: '12 กพ. 2564',
          viewAndDownLoad: 'แสดง  ดาวน์โหลด',
        },
      ],
    },
  }

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getContractor(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema && <ContractSigningWidgets schema={schema?.forms?.contractorList} />}
      </SidebarProposal>
    </>
  )
}
